import { Flex } from '@iheartjane/reefer';
import { clsx } from 'clsx';
import type { MouseEvent } from 'react';

import styles from './selectedIndicator.module.css';

interface SelectedIndicatorProps {
  disabled?: boolean;
  isSelected: boolean;
  onToggle: () => void;
  productName: string;
}

/** Toggles a product card's selection. The caller decides when to show it. */
export const SelectedIndicator = ({
  disabled = false,
  isSelected,
  onToggle,
  productName,
}: SelectedIndicatorProps) => {
  const handleClick = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onToggle();
  };

  return (
    <Flex background="grays-white" border="grays-ultralight" borderRadius="xl">
      <button
        type="button"
        className={clsx(styles['indicator'], {
          [styles['indicator_selected']]: isSelected,
        })}
        disabled={disabled && !isSelected}
        onClick={handleClick}
        aria-label={`Select ${productName}`}
        aria-pressed={isSelected}
      >
        <span className={styles['dot']} aria-hidden="true" />
      </button>
    </Flex>
  );
};
